export const REGISTER_WS = 'register_ws';
export const REGISTER_WS_SUCCESSFUL = 'register_ws_successfull';
export const REGISTER_WS_FAILED = 'register_ws_failed';



